import { render } from "./StudentAssign.vue?vue&type=template&id=2b5ee1a7"
import script from "./StudentAssign.vue?vue&type=script&lang=js"
export * from "./StudentAssign.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__